export default "__VITE_ASSET__C8L1HqDh__"